export const statusBadgeMap: Record<
  string,
  { className: string; icon: string; label: string }
> = {
  PENDING: {
    className: 'badge-warning',
    icon: 'ni-clock',
    label: 'TradingOfferOperationStatus_Pending',
  },
  KYC_REVIEW: {
    className: 'badge-info',
    icon: 'ni-shield-check',
    label: 'TradingOfferOperationStatus_KYCReview',
  },
  VALIDATION: {
    className: 'badge-warning',
    icon: 'ni-clock',
    label: 'TradingOfferOperationStatus_Validation',
  },
  PAYMENT_PENDING: {
    className: 'badge-warning',
    icon: 'ni-wallet',
    label: 'TradingOfferOperationStatus_Payment',
  },
  TRANSFER_PENDING: {
    className: 'badge-info',
    icon: 'ni-swap',
    label: 'TradingOfferOperationStatus_Transfer',
  },
  COMPLETED: {
    className: 'badge-success',
    icon: 'ni-check-circle',
    label: 'TradingOfferOperationStatus_Completed',
  },
  CANCELLED: {
    className: 'badge-danger',
    icon: 'ni-cross-circle',
    label: 'TradingOfferOperationStatus_Cancelled',
  },
  REJECTED: {
    className: 'badge-danger',
    icon: 'ni-cross-circle',
    label: 'TradingOfferOperationStatus_Rejected',
  },
};

export const statusBannerMap: Record<
  string,
  { className: string; icon: string; heading: string; message: string }
> = {
  PENDING: {
    className: 'alert-warning',
    icon: 'ni-clock',
    heading: 'TradingOfferOperationHeading_Pending',
    message: 'TradingOfferOperationMessage_Pending',
  },
  KYC_REVIEW: {
    className: 'alert-info',
    icon: 'ni-shield-check',
    heading: 'TradingOfferOperationHeading_KYCReview',
    message: 'TradingOfferOperationMessage_KYCReview',
  },
  VALIDATION: {
    className: 'alert-warning',
    icon: 'ni-clock',
    heading: 'TradingOfferOperationHeading_Validation',
    message: 'TradingOfferOperationMessage_Validation',
  },
  PAYMENT_PENDING: {
    className: 'alert-warning',
    icon: 'ni-wallet',
    heading: 'TradingOfferOperationHeading_Payment',
    message: 'TradingOfferOperationMessage_Payment',
  },
  TRANSFER_PENDING: {
    className: 'alert-info',
    icon: 'ni-swap',
    heading: 'TradingOfferOperationHeading_Transfer',
    message: 'TradingOfferOperationMessage_Transfer',
  },
  COMPLETED: {
    className: 'alert-success',
    icon: 'ni-check-circle',
    heading: 'TradingOfferOperationHeading_Completed',
    message: 'TradingOfferOperationMessage_Completed',
  },
  CANCELLED: {
    className: 'alert-danger',
    icon: 'ni-cross-circle',
    heading: 'TradingOfferOperationHeading_Cancelled',
    message: 'TradingOfferOperationMessage_Cancelled',
  },
  REJECTED: {
    className: 'alert-danger',
    icon: 'ni-cross-circle',
    heading: 'TradingOfferOperationHeading_Rejected',
    message: 'TradingOfferOperationMessage_Rejected',
  },
};

export const timelineStepConfig: Record<
  string,
  { icon: string; description: string }
> = {
  PENDING: {
    icon: 'ni-file-text',
    description: 'TradingOfferOperationTimeline_Pending',
  },
  KYC_REVIEW: {
    icon: 'ni-shield-check',
    description: 'TradingOfferOperationTimeline_KYCReview',
  },
  VALIDATION: {
    icon: 'ni-building',
    description: 'TradingOfferOperationTimeline_Validation',
  },
  PAYMENT_PENDING: {
    icon: 'ni-cc-alt2',
    description: 'TradingOfferOperationTimeline_Payment',
  },
  TRANSFER_PENDING: {
    icon: 'ni-swap',
    description: 'TradingOfferOperationTimeline_Transfer',
  },
  COMPLETED: {
    icon: 'ni-file-check',
    description: 'TradingOfferOperationTimeline_Completed',
  },
  CANCELLED: {
    icon: 'ni-cross-circle',
    description: 'TradingOfferOperationTimeline_Cancelled',
  },
  REJECTED: {
    icon: 'ni-cross-circle',
    description: 'TradingOfferOperationTimeline_Rejected',
  },
};

export const activityAvatarMap: Record<string, { bg: string; icon: string }> = {
  PENDING: { bg: 'bg-primary-dim', icon: 'ni-user' },
  KYC_REVIEW: { bg: 'bg-success-dim', icon: 'ni-shield-check' },
  VALIDATION: { bg: 'bg-info-dim', icon: 'ni-send' },
  PAYMENT_PENDING: { bg: 'bg-warning-dim', icon: 'ni-wallet' },
  TRANSFER_PENDING: { bg: 'bg-info-dim', icon: 'ni-swap' },
  COMPLETED: { bg: 'bg-success-dim', icon: 'ni-check-circle' },
  CANCELLED: { bg: 'bg-danger-dim', icon: 'ni-cross-circle' },
  REJECTED: { bg: 'bg-danger-dim', icon: 'ni-cross-circle' },
};

export const menuStatusOptions = [
  { key: 'PENDING', icon: 'ni-file-text' },
  { key: 'KYC_REVIEW', icon: 'ni-shield-check' },
  { key: 'VALIDATION', icon: 'ni-building' },
  { key: 'PAYMENT_PENDING', icon: 'ni-cc-alt2' },
  { key: 'TRANSFER_PENDING', icon: 'ni-swap' },
  { key: 'COMPLETED', icon: 'ni-file-check' },
] as const;
